import { defineMessages } from 'react-intl';

export const PromotionComponentLayout1Messages = defineMessages({
  ChipLabel: { id: 'ic.promotion.layout1.chipLabel', defaultMessage: 'TIPP' },
  From: {
    id: 'ic.promotion.layout1.from',
    defaultMessage: 'oder ab',
  },
  InstallmentsPrefix: {
    id: 'ic.promotion.layout1.installments.prefix',
    defaultMessage: 'in',
  },
  Installments: {
    id: 'ic.promotion.layout1.installments',
    defaultMessage: '{installments} Raten',
  },
  CtA: {
    id: 'ic.promotion.layout1.cta',
    defaultMessage: 'Wunschrate berechnen',
  },
});
